module.exports = __webpack_public_path__ + "img/banner-page.c3729025.png";